import React from 'react';
import PropTypes from 'prop-types';
import ExplainHeader from '~/component/login/H5/ExplainHeader';
// eslint-disable-next-line import/no-unresolved
import './index.less';

const H5AccessError = ({imgSrc, imgAlt, title, msg}) => (
    <div className="h5-access-error-wrapper">
        <ExplainHeader class="access-error-explain">单点登录系统</ExplainHeader>
        <div className="access-error">
            <div className="content-wrapper">
                <div className="img-wrapper">
                    <img
                        src={imgSrc}
                        alt={imgAlt}
                    />
                </div>

                <p className="title">
                    {title}
                </p>
                <p className="msg">
                    {msg}
                </p>
            </div>
        </div>
    </div>
);

H5AccessError.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
};

export default H5AccessError;
